module.exports = __webpack_public_path__ + "static/media/cover-del-valle-coco.1d3ac7bb.png";